import React from 'react';
import Button from '../../../components/ui/Button';

const ViewToggle = ({ currentView, onViewChange }) => {
  const views = [
    { id: 'list', label: 'Liste', icon: 'List' },
    { id: 'calendar', label: 'Kalender', icon: 'Calendar' }
  ];

  return (
    <div className="flex items-center space-x-1 bg-muted/50 p-1 rounded-lg">
      {views?.map((view) => (
        <Button
          key={view?.id}
          variant={currentView === view?.id ? "default" : "ghost"}
          size="sm"
          iconName={view?.icon}
          iconPosition="left"
          iconSize={16}
          onClick={() => onViewChange(view?.id)}
          className="px-3 py-2"
        >
          {view?.label}
        </Button>
      ))}
    </div>
  );
};

export default ViewToggle;